import { formatNumber } from '@forwardflow/helpers/utils/formatNumber'
import { Avatar } from 'antd'

const TopAgentsPersonas = ({ topAgentPersonas }: { topAgentPersonas: any }) => {
   return (
      <>
         <div className="bg-[#3B3C42] rounded text-[14px] font-medium h-full">
            <p className="px-8 py-5 border-b border-white/20">
               Top Agent Personas
            </p>
            <div className="flex h-full flex-col py-3 gap-y-4 overflow-y-auto max-h-[210px]">
               {topAgentPersonas && topAgentPersonas.length > 0 ? (
                  topAgentPersonas.map((item: any, index: number) => (
                     <div
                        key={index + (item?.user?.name || 'unknown')}
                        className="flex items-center justify-between px-7"
                     >
                        <div className="flex items-center flex-1 gap-x-3">
                           <Avatar>
                              {item?.user?.name
                                 ? item.user.name
                                      .split(' ')
                                      .map((word: string) => word.charAt(0))
                                      .join('')
                                 : '?'}
                           </Avatar>
                           <p>{item?.user?.name || 'Unknown Agent'}</p>
                        </div>
                        <div className="text-white/70">
                           {formatNumber(item?.totals?.appointments)} Appt.
                        </div>
                     </div>
                  ))
               ) : (
                  <div className="flex items-center justify-center py-8">
                     <p className="text-white/70 text-[14px]">
                        No data available
                     </p>
                  </div>
               )}
            </div>
         </div>
      </>
   )
}

export default TopAgentsPersonas
